<script setup>
import {displayHandle} from '~/utils/display-handle.mjs';
	import useEmitter from '~/composables/useEmitter';
	
	const props = defineProps({ profile: Object, isOwner: Boolean });
	const client = useUser();
 const social=inject('profileFollowing');
	const emitter = useEmitter();
	const updatedAt = relativeDate(props.profile.updated_at);

	const key = ref(0);
	const upload = async (e) => {
		const body = new FormData(e.target.form);
		const { data } = await $fetch('/api/images/upload', { method: "POST", body });
		key.value += 1;
	}
</script>

<template>

	<form class="uo-card uo-profile-card" @submit.prevent>
        <div class="uo-profile-identity">
			<label :class="{'cursor-pointer': isOwner}" class="uo-profile-avatar flex-shrink-0 grid justify-self-center place-items-center rounded-full aspect-square overflow-hidden">
				<Userpic class="userpic col-start-1 row-start-1 w-14 h-14 xs:w-16 xs:h-16" :src="`/files/userpic/${profile.id}.webp?key=${key}`" :name="profile.name" />
				<template v-if="isOwner">
					<div class="uo-profile-avatar-camera grid place-items-center col-start-1 row-start-1 bg-black/40 w-full z-10 aspect-square" aria-hidden="true">
						<svg-icon class="opacity-60 text-white" name="camera" width="48" heigth="48" />
					</div>
					<input type="hidden" name="entity_type" value="User">
					<input type="file" name="file" aria-label="Заменить аватарку" accept="image/*" class="clip-hidden inset-0" @change="upload">
				</template>
			</label>
			<div class="uo-profile-description">
				<div class="uo-profile-name">{{ profile.name }}</div>
				<div class="uo-profile-nickname">{{ displayHandle(profile.nickname) }}</div>
				<div class="uo-profile-visit">Последний визит: {{ updatedAt }}</div>
			</div>
		</div>
		<div class="uo-profile-actions" :class="{'is-owner':isOwner}"><NuxtLink v-if="isOwner" class="uo-btn uo-btn-secondary" :to="`/profiles/${profile.id}/edit`">Редактировать профиль</NuxtLink>
            <button v-if="!isOwner&&social" type="button" class="uo-btn" :class="social.data.value?.is_following?'uo-btn-secondary':'uo-btn-primary'" :disabled="social.busy.value||(!social.data.value&&!social.error.value)" :aria-pressed="!!social.data.value?.is_following" :title="social.data.value?.is_following?'Отписаться от автора':'Новые посты, итоги экспериментов и рекорды — в уведомлениях'" @click="social.follow">{{social.busy.value?'Сохраняем…':social.data.value?.is_following?'Отписаться':'Подписаться'}}</button>
			<button class="uo-btn uo-btn-secondary uo-profile-message" v-if="!isOwner" type="button" aria-label="Написать сообщение" @click="emitter.emit('chat:open', profile)"><span class="uo-profile-message-full">Написать сообщение</span><span class="uo-profile-message-short">Сообщение</span></button>
        </div>
        <p v-if="social?.failure.value" class="uo-follow-error" role="alert">{{social.failure.value}}</p>
    </form>
</template>

<style scoped>
.uo-profile-avatar-camera{opacity:0;pointer-events:none;transition:opacity .15s ease;}
.uo-profile-avatar:hover .uo-profile-avatar-camera,.uo-profile-avatar:focus-within .uo-profile-avatar-camera{opacity:1;}
.uo-profile-avatar:focus-within{outline:2px solid var(--uo-color-border-focus);outline-offset:3px;}
.uo-profile-description{min-width:0;display:grid;gap:4px;overflow-wrap:anywhere;}
.uo-profile-nickname,.uo-profile-visit{color:var(--uo-color-text-secondary);font:400 14px/20px var(--uo-typography-fontFamily-ui);}
.uo-profile-actions{display:flex;gap:var(--uo-spacing-2);align-items:center;flex-wrap:wrap;flex-shrink:0;}.uo-profile-message-short{display:none}.uo-follow-error{flex-basis:100%;margin:0;color:var(--uo-color-status-danger);font-size:14px;line-height:20px;}
@media(max-width:767px){.uo-profile-card{padding:16px;gap:16px;}.uo-profile-identity{gap:12px;}.uo-profile-identity :deep(.userpic){width:64px;height:64px;}.uo-profile-name{font-size:20px;line-height:28px;}.uo-profile-visit{font-size:12px;line-height:16px;}.uo-profile-actions{width:100%;flex-wrap:nowrap;}.uo-profile-actions>.uo-btn{flex:1;min-width:0;padding-inline:12px;font-size:14px;white-space:nowrap;}.uo-profile-message-full{display:none}.uo-profile-message-short{display:inline}.uo-profile-actions.is-owner{display:none;}}
</style>
